import React from "react";
import {
  Select as MuiSelect,
  SelectProps,
  MenuItem,
  Typography,
  styled,
} from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Index";

const FieldLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "textcolor",
})<{ textcolor?: string }>(({ textcolor }) => ({
  fontSize: "13px",
  fontWeight: 500,
  opacity: 0.9,
  color: textcolor,
  marginBottom: "6px",
  lineHeight: 1.4,

  "& span.required": {
    color: "#ff4d4f",
    marginLeft: "2px",
  },
}));

const StyledSelect = styled(MuiSelect, {
  shouldForwardProp: (prop) => prop !== "selectbg",
})<{ selectbg?: string }>(({ selectbg }) => ({
  width: "100%",
  backgroundColor: selectbg,
  borderRadius: "30px",
  fontSize: "13px",
  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
  "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
  "& .MuiSelect-select": { padding: "10px 14px" },
}));

export interface PillSelectOption {
  value: string | number;
  label: string;
}

export interface PillSelectProps extends Omit<SelectProps, "variant"> {
  label?: string;
  required?: boolean;
  options?: PillSelectOption[];
  selectbg?: string;
  labelColor?: string;
}

const PillSelect: React.FC<PillSelectProps> = ({
  label,
  required,
  options,
  selectbg,
  labelColor,
  children,
  ...props
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const color100 = reduxTheme.primary_colors?.[100];
  const color800 = reduxTheme.primary_colors?.[800];

  return (
    <>
      {label && (
        <FieldLabel textcolor={labelColor ?? color100}>
          {label}
          {required && <span className="required">*</span>}
        </FieldLabel>
      )}
      <StyledSelect
        variant="outlined"
        selectbg={selectbg ?? color800}
        {...props}
      >
        {options
          ? options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))
          : children}
      </StyledSelect>
    </>
  );
};

export default PillSelect;
